import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initImagePreloader } from "@/utils/imagePreloader";

// Initialize image preloading for faster page loads
initImagePreloader();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
